<script lang="ts">
import Button from "../../materialize/components/Button.svelte";
import Icon from "../../materialize/components/Icon.svelte";
import ModalWindow from "../../materialize/components/ModalWindow.svelte";
import Panel from "../../materialize/components/Panel.svelte";
import ProgressBar from "../../materialize/components/ProgressBar.svelte";
import InputField from "../../materialize/forms/InputField.svelte";
import Label from "../../materialize/forms/Label.svelte";
import TextField from "../../materialize/forms/TextField.svelte";
import Center from "../../materialize/grid/Center.svelte";
import Column from "../../materialize/grid/Column.svelte";
import Row from "../../materialize/grid/Row.svelte";
import { get_host } from "../../settings";
import { current_dialect } from "../../stores/stores";
import { get_cookie } from "../../utils/cookie_manager";
import { promise_or_go_offline } from "../../utils/fetch_or_go_offline";
import SendEmailButton from "../../utils/SendEmailButton.svelte";
import Spinner from "../../utils/Spinner.svelte";

let new_suggestion = {
    "text_suggestion_ita": "",
    "text_suggestion_dialect": "",
    "dialect": $current_dialect.id,
    "comment": ""
};

let post_promise = null;

let completed: boolean = false;

let modal;
function submit_suggestion()
{
    const my_headers = new Headers();
    my_headers.append("X-CSRFToken", get_cookie("csrftoken"));
    my_headers.append('Accept', 'application/json');
    my_headers.append('Content-Type', 'application/json');


    post_promise = promise_or_go_offline(
        fetch(
            get_host() + `/api/dictionary/suggestions`,
            {
                method: "POST",
                headers: my_headers,
                body: JSON.stringify(new_suggestion),
            })
        ).then(
            (res) => {
                if (res.ok) {
                    setTimeout(()=>{completed=true; modal.close()}, 3500);
                    return res;
                } else {
                    throw new Error("Error adding suggestion");
                }
            }
        );
}

</script>

{#if !completed}
<Button on:click={()=>{modal.open()}}>
    Suggerisci parola mancante
</Button>
{:else}
<Panel> Ci hai inviato correttamente il tuo suggerimento. Grazie! <Icon icon="check"></Icon></Panel>
{/if}



<ModalWindow bind:this={modal}>

{#if post_promise}
    {#await post_promise}
        <Spinner></Spinner>
    {:then d}
    <Center>
        <Icon class_list={["approu-primary-text", "text-darken-1", "large"]}  icon="check"></Icon>
    </Center>
        <h3>Grazie</h3>
        Suggerimento inviato correttamente
    {:catch}
        Errore nell'invio del suggerimento. Riprova più tardi o contattaci per segnalare il problema <SendEmailButton button_text="Contattaci"></SendEmailButton>
    {/await}
{:else}
    <form on:submit|preventDefault={submit_suggestion}>
        <Row>
            <Column>
                <h3>Suggerisci una parola</h3>
            </Column>
        </Row>
        <Row>
            <Column small={12}>
                <InputField>
                    <TextField
                        bind:value={new_suggestion.text_suggestion_ita}
                        required={false}
                        label_text="Parola in italiano"
                        id="field_word_ita"
                    />
                </InputField>
            </Column>
            <Column small={12}>
                <InputField>
                    <TextField
                        bind:value={new_suggestion.text_suggestion_dialect}
                        required={false}
                        label_text={`Parola in ${$current_dialect.name.toLocaleLowerCase()}`}
                        id="field_word_dial"
                    />
                </InputField>
            </Column>
            <Column small={12}>
                <InputField>
                    <TextField
                        bind:value={new_suggestion.comment}
                        required={false}
                        label_text="Un commento o il contesto della traduzione"
                        id="field_comment"
                    />
                </InputField>
            </Column>
        </Row>
        <Row>
            <Column>
                <Button disabled={new_suggestion.text_suggestion_ita || new_suggestion.text_suggestion_dialect ? false : true}>Invia</Button>
            </Column>
        </Row>
        
    </form>
{/if}
</ModalWindow>